/**
 * CR500: DatesBlock
 * 
 * Renders deal validity dates and source information.
 * Extracted from DealGiftCard for v2 block-based rendering.
 */

import React from "react";
import type { DealCardBlockProps } from "@/lib/deal-cards/specV2/types";
import type { Deal } from "@/lib/types/deals";
import {
  formatValidity,
  formatBonusValidity,
  formatWhereFound,
} from "@/lib/types/deals";

export const DatesBlock: React.FC<DealCardBlockProps<Deal>> = ({
  deal,
  block,
  context,
}) => {
  // Don't render if block is disabled
  if (!block.enabled) {
    return null;
  }

  const validity = formatValidity(deal);
  const bonusValidity = formatBonusValidity(deal);
  const whereFound = formatWhereFound(deal);

  // If all values are empty, don't render the block
  if (!validity && !whereFound && !bonusValidity) {
    return null;
  }

  return (
    <div 
      className="mt-3 space-y-1 text-sm text-muted-foreground"
      data-block="dates"
      data-block-id={block.id}
    >
      {validity && <p>{validity}</p>}
      {whereFound && <p>{whereFound}</p>}
      {bonusValidity && (
        <p className="text-accent font-medium">{bonusValidity}</p>
      )}
    </div>
  );
};

export default DatesBlock;
